import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fetchStaffEstablishmentAssignmentsQueryOptions } from "@/api/establishmentStaff";
import { fetchOrganizationEstablishmentsQueryOptions } from "@/api/establishments";
import { fetchStaffMemberByIdQueryOptions } from "@/api/staff";
import { useApiParameters } from "@/hooks/useApiParameters";
import { StaffPermissionsForm } from "@/routes/_auth/app/_app/org/$orgId/staff/-components/StaffPermissionsForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/staff/$staffId/permissions",
)({
	loader: async ({ context, params }) => {
		const { userId, token } = useApiParameters(
			context.userId,
			await context.get_token(),
		);
		const { orgId, staffId } = params;

		// Preload staff member data
		await context.queryClient.ensureQueryData(
			fetchStaffMemberByIdQueryOptions(userId, token, orgId, staffId),
		);

		// Preload establishments data
		await context.queryClient.ensureQueryData(
			fetchOrganizationEstablishmentsQueryOptions(userId, token, orgId),
		);

		// Preload staff establishment assignments
		await context.queryClient.ensureQueryData(
			fetchStaffEstablishmentAssignmentsQueryOptions(token, orgId, staffId),
		);

		return { userId, token, orgId, staffId };
	},
	component: StaffPermissionsPage,
});

function StaffPermissionsPage() {
	const { orgId, staffId } = Route.useParams();
	const { userId, token } = Route.useLoaderData();

	// Fetch staff member data
	const { data: staffMember } = useSuspenseQuery(
		fetchStaffMemberByIdQueryOptions(userId, token, orgId, staffId),
	);

	return (
		<div className="h-full flex flex-col space-y-6">
			<div
				className="h-full overflow-auto"
				data-testid="staff-permissions-container"
			>
				<StaffPermissionsForm
					staffMember={staffMember}
					organizationId={orgId}
					token={token}
				/>
			</div>
		</div>
	);
}
